import axios from 'axios';

const state = {
  coupon_transactions: [],
  pagination: {
    page: 1,
    perPage: 10,
    totalItems: 0,
    previousPageLink: null,
    nextPageLink: null
  }
};

const actions = {
  async fetchCouponTransactionByCustomerId(_, customer_id) {
    const token = localStorage.getItem('auth_token');
    const response = await axios.get(`${process.env.VUE_APP_ROOT_API}/coupon-transactions?customer_id=${customer_id}`, {
      headers: {
      'Authorization': `Bearer ${token}`
      }
    });

    return response.data;
    // commit('setTransactions', data);
    // commit('setPagination', data.pagination);
  }
}

const mutations = {
  SET_COUPON_TRANSACTIONS(state, coupon_transactions) {
    if (coupon_transactions && coupon_transactions.data && Array.isArray(coupon_transactions.data)) {
      state.coupon_transactions = coupon_transactions.data;
    } else {
      state.coupon_transactions = [];
    }
  }
}

const getters = {
  allCouponTransactions: (state) => state.coupon_transactions,
}

export default {
  namespaced: true,
  state, mutations, actions, getters
}